






























import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import InfoBox from "./Infobox.vue"
import ConstructingBar from "./ConstructingBar.vue"
import { Game } from "../models/game"
import { EnergySource } from "../models/energy-source"
import { Howl } from "howler"

@Component({
  components: {
    InfoBox,
    ConstructingBar
  }
})
export default class ResourceEntity extends Vue {
  @Prop(String) public imageSrc: string
  @Prop() public hasSource: any
  @Prop(Number) public isConstructing: number
  @Prop(String) public name: string
  @Prop(Boolean) public demo: boolean | undefined
  public money: number
  public notifications: number = 0

  get day() {
    return (this.$store.state as Game).totalDays
  }

  get amt() {
    this.$store.state.inventory.inventoryChangeNum
    // return this.$store.state.inventory.getBuiltCount(this.name)
    const thesource = Array.from(this.$store.state.inventory.energySources.keys()).find(
      (es: EnergySource) => es.name === this.name
    )!
    const foo = this.$store.state.inventory.energySources.get(thesource)
    if (foo == null) {
      return 0
    } else {
      let sum = 0
      for (const item of foo) {
        if (item.isBuilt) {
          sum += 1
        }
      }
      return sum
    }
  }

  @Watch("day")
  public displayNotification(oldval: number, newval: number) {
    if (!this.isConstructing && this.hasSource) {
      this.money = (this.$store.state as Game).energySources.find(
        (src: EnergySource) => src.name === this.name
      ).profitMargin
      this.notifications++
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Money gained.mp3"]
        }).play()
      }
    }
  }
}
